import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./CardEffect.css";

import resumeEs from "../../assets/document/Alejandra_Arevalo_CV_Spanish.pdf";
import resumeEn from "../../assets/document/Alejandra_Arevalo_CV_English.pdf";

export const CardEffect = ({ image, text, isLink = false, className = "" }) => {
  const { i18n } = useTranslation();

  const handleDownload = () => {
    const isEnglish = i18n.language === "en";
    const link = document.createElement("a");
    link.href = isEnglish ? resumeEn : resumeEs;
    link.download = isEnglish
      ? "Alejandra_Arevalo_CV_English.pdf"
      : "Alejandra_Arevalo_CV.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={`card-effect playing ${className}`}>
      <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div>

      <div className="card-effect__body">
        <img
          className={`card-effect__image`}
          src={image}
          alt="Alejandra Arevalo"
        />

        {isLink ? (
          <Button href="#contact" className="card-effect__button" type="submit">
            {text}
          </Button>
        ) : (
          <Button
            onClick={handleDownload}
            className="card-effect__button"
            type="submit"
          >
            {text}
          </Button>
        )}
      </div>
    </div>
  );
};
